import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import Header from './Header';
import useTokenExpiry from '../hooks/useTokenExpiry';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.3s ease;
  margin-left: ${props => props.sidebarOpen ? '200px' : '0'};
  width: ${props => props.sidebarOpen ? 'calc(100vw - 200px)' : '100vw'};
  max-width: ${props => props.sidebarOpen ? 'calc(100vw - 200px)' : '100vw'};
`;

const ContentArea = styled.div`
  flex: 1;
  padding: 20px;
  
  @media (max-width: 700px) {
    padding: 15px;
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: ${props => props.show ? 'block' : 'none'};
  
  @media (min-width: 901px) {
    display: none;
  }
`;

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  // 토큰 만료 체크
  useTokenExpiry();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth <= 1000);
      // 1000px 이하에서는 사이드바를 닫고, 1000px 이상에서는 열어둠
      if (window.innerWidth <= 1000) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    if (isSmallScreen) {
      setSidebarOpen(false);
    }
  };

  return (
    <LayoutContainer>
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      {isSmallScreen && sidebarOpen && <Overlay show={sidebarOpen} onClick={closeSidebar} />}
      <MainContent sidebarOpen={sidebarOpen}>
        <Header onToggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
        <ContentArea>
          {children}
        </ContentArea>
      </MainContent>
    </LayoutContainer>
  );
};

export default Layout;